
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'pinLabel': 'Pin',
	'find_label': 'Find',
	'findCancelLabel': 'Cancel',
	'dataPaneLabel': 'Data',
	'sourcePaneLabel': 'Selected sources',
	'sourcePaneContentLabel': 'Select a source',
	'emptySourcePaneTitle': 'Select a source',
	'emptySourcePaneCaption': 'Click select a source to add data to use to build a dashboard.',
	'addDataSource': 'Select a source',
	'addDataDashboardCoachMarkContents': 'Drag and drop data from the data panel onto your dashboard.',
	'addDataStoryCoachMarkContents': 'Drag and drop data from the data panel onto your story.',
	'addDataCoachMarkTitle': 'Add data',
	'selectSourcesText': 'Select and add a data source to build your %{app}.',
	'selectSourcesLabel': 'Select a source',
	'errorSourcesTitle': 'Failed to load data tree',
	'errorLoadingDataSources': 'An error occurred while loading the list of data sets',
	'errorLoadingDataTree': 'An error occurred while loading the tree',
	'dataSetPaneLastUpdated': 'Last updated: %{date}',
	'dataSourcePaneDateUnknown': 'Unknown',
	'moreTitle': 'More',
	'backLabel': 'Go back',
	'addDataSourceDialogTitle': 'Select a source',
	'addDataSourceDialogButtonLabel': 'Add',
	'dlg_use': 'Use',
	'dlg_RelinkDataSourceTitle': 'Replace data set "%{dataSourceName}" with ...',
	'propertiesDialogTitle': 'Properties',
	'loadingMetadata': 'Loading metadata',
	'missingDataSetData': 'The data for this data set is not available. Refresh the data set or contact your administrator for access to the source.',
	'errorLoadingSource': 'The metadata for "%{sourceName}" did not load. Please contact your administrator for details.',
	'errorMessageTitle': 'Error',
	'calculation_navigation_in_use': 'Deleting calculations, filters or navigation paths invalidates all visualizations that reference the deleted item. Are you sure you want to delete?',
	'delete_confirm': 'Confirm delete',
	'previewUnavailable': 'The data tray and global filters are unavailable for this package type.',
	'contextualGridTabName': 'Visualization data',
	'DATA_TRAY_no_data_text': 'You don\'t currently have any data',
	'contextualGridMenuLabel': 'Visualization data menu',
	'contextualGridExport': 'Export',
	'nullValueText': 'Null',
	'forecastDetailsTabName': 'Forecasting statistical details',
	'forecastDetailsModelLabel': 'Model',
	'forecastDetailsQualityMetricLabel': 'Accuracy Measures',
	'forecastDetailsSmoothingCoefLabel': 'Parameters',
	'forecastDetailsDiagnostics': 'Diagnostics',
	'forecastDetailsForecastLabel': 'Forecast',
	'forecastDetailsStatusLabel': 'Status',
	'forecastDetailsAccuracyPercentLabel': 'Accuracy %',
	'forecastDetailsTrendLabel': 'Trend',
	'forecastDetailsSeasonLabel': 'Seasonality',
	'forecastDetailsSeasonalPeriodLabel': 'Seasonal period',
	'forecastDetailsAlphaLabel': 'Alpha',
	'forecastDetailsBetaLabel': 'Beta',
	'forecastDetailsGammaLabel': 'Gamma',
	'forecastDetailsPhiLabel': 'Phi',
	'forecastDetailsMissingCount': 'Missing count',
	'forecastDetailsSeriesLengthLabel': 'Series length',
	'forecastDetailsIgnoredPeriods': 'Ignored periods',
	'forecastDetailsTrendStrength': 'Trend strength',
	'forecastDetailsSeasonalityStrength': 'Seasonality strength',
	'forecastDetailsTimeDeltaUnit': 'Date / time interval',
	'forecastDetailsNotes': 'Notes'
});
